import { useQuery } from 'data-fetching-client';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
import { GET_PUBLIC_PRICING_PAGE_DETAILS_QUERY } from '../../../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc.dfc.new';
import { DEFAULT_CHIRP_TIMEOUT } from '../../../utils/dataFetchingClient';
import { getCountryCodeFromLocale } from '../../utils/countryCodeUtils';
export const usePublicPricingPageDetails = ({
  isAppAuth = false
}) => {
  const browserLocale = getPreferredLanguage().toLowerCase() || 'en-us';
  const preferredCountryCode = getCountryCodeFromLocale();
  const {
    data,
    error,
    loading
  } = useQuery(GET_PUBLIC_PRICING_PAGE_DETAILS_QUERY, {
    variables: {
      browserLocale,
      preferredCountryCode: preferredCountryCode ? preferredCountryCode : undefined
    },
    skip: isAppAuth,
    context: {
      timeout: DEFAULT_CHIRP_TIMEOUT
    }
  });
  return {
    data: data === null || data === void 0 ? void 0 : data.result,
    error,
    loading
  };
};